enum ContentCategory {
  WorldView,
  DER,
  Culture,
  WildLife, // Wild life and nature
  BehindTheExpedition,
}

export default ContentCategory;
